import React, { useEffect, useState } from "react";
import "./RateQuote.css";

import { commaizeFloat } from "../../Common";
import { useSelector } from 'react-redux';

import { Table,Tabs, Switch, Popover, Button, Modal, Tooltip, Input, Select,Row, Col, Divider, Checkbox} from 'antd';
import { CodeSandboxCircleFilled, QuestionCircleOutlined } from '@ant-design/icons';
import Lenders from "../../Management/Lenders";
import CompareProduct from "./CompareProductModal";
import { checkAccess } from "../../Auth";
import { UR_Owner, UR_LoanOfficer, UR_PriceEngineUser } from "../../State";
import * as com from "../../Common";
import "./NewAllRates.css";
import { ineligibleColumns } from "./IneligibleReason";
import { formatAdjustmentName as handleName } from "./adjustmentName";
import ClosingCostFeeModal from "./components/closingCostDetail/closingCostFeeModal";
import moment from 'moment';
import { track } from 'statsig'
import { STATSIG } from 'statsig/events'
import { armCadenceLabel } from "../PPEPricing/armTerms";

const {TabPane}=Tabs;



const typemap = {
  fixed40: "40 Year",
  fixed30: "30 Year",
  fixed25: "25 Year",
  fixed20: "20 Year",
  fixed15: "15 Year",
  fixed10: "10 Year",
  arm56: "ARM 5 Year",
  arm76: "ARM 7 Year",
  arm106: "ARM 10 Year",
  arm31: "ARM 3 Year",
}

// The PPE page searches by fixed period + cadence (arm31 ... arm106; older
// saved searches arm3/arm5/arm7/arm10) while the result buckets keep their
// historical keys, one bucket per fixed period -- an unmapped term made
// targetTab undefined and .outtabledata blanked the whole page.
const TERM_TO_BUCKET = {
  arm3: "arm31", arm36: "arm31",
  arm5: "arm56", arm51: "arm56",
  arm7: "arm76", arm71: "arm76",
  arm10: "arm106", arm101: "arm106",
};

// Small "5/6 SOFR" label after an ARM product's name, from its ARM fields.
function ArmCadenceTag({ arm }) {
  const label = armCadenceLabel(arm);
  if (!label) return null;
  return (
    <div
      className="arm-cadence-tag"
      style={{display: "inline-block", marginTop: 2, padding: "0 6px", borderRadius: 4, background: "#EAEFFD", color: "#325CEB", fontSize: 12, lineHeight: "18px", fontWeight: 500, whiteSpace: "nowrap"}}
    >
      {label}
    </div>
  );
}

const loanTermLabelMap = {
  fixed40: "40 Year Fixed",
  fixed30: "30 Year Fixed",
  fixed25: "25 Year Fixed",
  fixed20: "20 Year Fixed",
  fixed15: "15 Year Fixed",
  fixed10: "10 Year Fixed",
  arm56: "5/6 ARM",
  arm76: "7/6 ARM",
  arm106: "10/6 ARM",
}

const skipKeywordsMap={
  "Agency": ["conforming","highbalance", "high-balance","high_balance","super_conforming","superconforming","super-conforming","agency"],
  "Jumbo": ["jumbo","fha_jumbo","va_jumbo"],
  "FHA": ["fha","fha_high_balance","fha_jumbo"],
  "VA": ["va","va_high_balance","va_jumbo"],
  "USDA": ["usda"],
  "Non-QM": ["nonqm", "non-qm","non_qm"],
}

// The engine applies Max Price to lock-day + adjustment points before
// compensation. Keep that transformation in one place so the table, target
// matching, and expanded calculation all use the same capped price.
export const getMaxPriceBreakdown = (rate) => {
  const prices = rate?.prices || {};
  const lockDayPoint = Number(prices.lockDayPoint) || 0;
  const adjustmentPoint = Number(prices.adjustmentPoint) || 0;
  const loanAmount = Number(rate?.loanAmount) || 0;
  const beforeCapPoints = lockDayPoint + adjustmentPoint;
  const rawCapPoints = rate?.maxPriceCap;
  const capPoints = Number(rawCapPoints) || 0;
  const hasMaxPriceCap = rawCapPoints != null;
  const afterCapPoints = hasMaxPriceCap && beforeCapPoints < capPoints
    ? capPoints
    : beforeCapPoints;

  return {
    hasMaxPriceCap,
    capPoints,
    beforeCapPoints,
    afterCapPoints,
    beforeCapPrice: 100 - beforeCapPoints,
    afterCapPrice: 100 - afterCapPoints,
    beforeCapAmount: beforeCapPoints * loanAmount / 100,
    capAmount: capPoints * loanAmount / 100,
    afterCapAmount: afterCapPoints * loanAmount / 100,
  };
};

// Connected lenders return the final net price/amount from the engine because
// compensation is part of that value. Unconnected lenders have no compensation
// and therefore use the same gross after-cap values as the Price column/detail.
export const getNetPricingBreakdown = (rate) => {
  const pricing = getMaxPriceBreakdown(rate);
  const isConnected = Boolean(rate?.isConnected);
  const points = isConnected ? Number(rate?.points) || 0 : pricing.afterCapPoints;
  const amount = isConnected ? Number(rate?.lender_credit) || 0 : pricing.afterCapAmount;
  return {
    ...pricing,
    points,
    price: 100 - points,
    amount,
  };
};

export function AllRatesTable(props) {
  const [showRowDetail, setShowRowDetail] = useState(true);
  const [emptyTargetRate,setEmptyTargetRate] = useState(false)
  const [allresults,setAllResults] = useState(0);
  const [connectedresults,setConnectedResults] = useState(0);
  const [activeTabKey, setActiveTabKey] = useState("fixed30");
  const [currentTarget,setCurrentTarget] = useState('price');
  // const [targetprice,setTargetPrice] = useState(3000);
  const [targetrate,setTargetRate] = useState(6.5);
  const [showAddLenderModal, setShowAddLendersModal] = useState(false);
  const [useDiscountFormat, setUseDiscountFormat] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [showShareRateModal, setShowShareRatesModal] = useState(false);
  const [compareModal, setCompareModal] = useState(false)
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { TextArea } = Input;
  const [eligibilityView, setEligibilityView] = useState("eligible");
  const [showClosingCostDetailModal, setShowClosingCostDetailModal] = useState(false);
  const [currentRecord, setCurrentRecord] = useState([])
  // 添加状态来跟踪每个展开行的内表数据是否显示全部
  const [expandedInnerTableStates, setExpandedInnerTableStates] = useState({});
  
  const currentLoan = useSelector(state => state.application.selection.selectedloan);
  
  let AllresultsCount={}
  let ConnectedresultsCount={}

  useEffect(() => {
    setAllResults(AllresultsCount[activeTabKey]);
    setConnectedResults(ConnectedresultsCount[activeTabKey])
  }, [activeTabKey,props.productTypes])

  useEffect(() => {
    // console.log('table', props.targetRate, props.targetPrice)
    setCurrentTarget(props.searchParams.searchBy)
    // console.log('table', props.searchParams.compensationType, props.loanInfo, props.downpayment)
  }, []);

  useEffect(() => {
    // console.log('searchParams-------------useEffect', props.searchParams.searchBy)
    setCurrentTarget(props.searchParams.searchBy)
  }, [props.searchParams.searchBy])

  useEffect(() => {
    // console.log('searchParams-------------useEffect rate', props.searchParams.targetRate)
    setTargetRate(props.searchParams.targetRate)
  }, [props.searchParams.targetRate])

  // 当数据更新时重置展开状态
  useEffect(() => {
    setExpandedInnerTableStates({});
  }, [props.allRates, props.loanterm, props.searchParams]);

  const handleTabChange=(key)=>{
    setActiveTabKey(key);
  };
  const getCurrentDate = () =>{
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    var today = new Date();

    const dayOfWeek = today.getDay();
    if (dayOfWeek === 0 || dayOfWeek === 6) {
      // If today is Sunday (0), subtract 2 days to get Friday
      // If today is Saturday (6), subtract 1 day to get Friday
      today = new Date(today.getFullYear(), today.getMonth(), today.getDate() - (dayOfWeek === 0 ? 2 : 1));
    }

    return today.toLocaleDateString("en-US", options);
  }

  const getRatesAfterSpecials = (record) => {
    if (record.Name.includes("WH_Conf_FHA_Comopp_D:") && record.Name.includes("30 Year Conforming")) {
    // if (record.Name.includes("Wh_Cnf")) {
      return (record.rate+props.specialAdjustments['Total']).toFixed(3)
    }
    if (record.Name.includes("WH_Conf_FHA_Comopp_D:") && record.Name.includes("30 Year Fha")) {
      return (record.rate+props.specialAdjustments['Total']).toFixed(3)
    }
    let totaladdback = 0
    if (record.Name.includes("Community Opportunity")){
      // if (Object.keys(props.specialAdjustments).includes("CRA")){
      //   totaladdback += 0.75
      // }
      // if (Object.keys(props.specialAdjustments).includes("Holiday")){
      //   totaladdback += 0.25
      // }
      return (record.rate+props.specialAdjustments['Total']).toFixed(3)
    }
  }
  const handleSelectRow = (record, isInnerTable = false) => {
    const key = record.key;
    const newSelectedRowKeys = selectedRowKeys.includes(key)
      ? selectedRowKeys.filter((k) => k !== key)
      : [...selectedRowKeys, key];
      
    setSelectedRowKeys(newSelectedRowKeys);
  }

  // 处理内表"Show all rates"按钮点击事件
  const handleShowAllRates = (recordKey) => {
    setExpandedInnerTableStates(prev => ({
      ...prev,
      [recordKey]: true
    }));
  }

  // 处理内表"收起"按钮点击事件
  const handleCollapseRates = (recordKey) => {
    setExpandedInnerTableStates(prev => ({
      ...prev,
      [recordKey]: false
    }));
  }

  const formatAmount = (amount) =>{
    const value = Number(amount);
    if(!Number.isFinite(value) || value === 0){
      return '-';
    }

    const formattedValue = Math.abs(value).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    return value > 0 ? `$${formattedValue}` : `-$${formattedValue}`;
  }

  const formatPricePoints = (value) => Number(value).toFixed(3)

  const maincolumns = [
    {
      title: <span style={{fontSize: 14, color: '#586570', fontWeight: 500, lineHeight: '24px'}}></span>,
      dataIndex: '',
      key: 'compare',
      width:"80px",
      className: "outerRateColumn",
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.key)}
          onClick={e => {
            e.stopPropagation();
          }}
          onChange={() => handleSelectRow(record)}
        />
      ),
    },
    {
      title: "Lender & Product", /*<Tooltip title="Originating institution and product name."></Tooltip>,*/
      dataIndex: 'program',
      key: 'program',
      width:"150px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <Tooltip
          overlayClassName='rates-lender-tooltip'
          arrow={false}
          placement="bottomLeft"
          title={
            <div>
              <div style={{fontFamily: 'Inter', fontSize:"16px", color:"#FFF", lineHeight: '20px'}}>{props.isCelebrity ? (record.Name.includes("Community Opportunity")?"No MI": record.Name.includes("Nonconforming")?"DTI 45%  No RSU for ARM":"") : record.Name}</div>
            </div>
          }
        >
          <div>
            <Row><div style={{fontSize:"16px", fontFamily: 'Inter', color: '#222', lineHeight: '20px', fontWeight: 600}}>{com.divideStringByCapitalLetter(record.Lender) === "GMCC Celebrities"?(record.Name.includes("Nonconforming")?"GMCC Celebrity Jumbo": record.Name.includes("Community Opportunity")?"GMCC Community Opportunity" : record.Name.includes("30 Year Conforming")? "GMCC Celebrity": "GMCC Celebrity FHA"):com.formatLenderDisplayName(record.Lender)}</div></Row>
            {props.isCelebrity && props.grantAvailable !== "None" && <div className="grantInfoBulb">{ props.grantAvailable === "10K"? "$10K Grant available" : props.grantAvailable === "5K"?"$5K Grant available":"$15K Grant available"}</div>}
            {props.isCelebrity ? 
              <div style={{overflow:"hidden",width:"180px",fontSize: 16,color:"#222",whiteSpace:"nowrap", textOverflow:'ellipsis', lineHeight: '20px'}}>{record.Name.includes("Community Opportunity")?"No MI": record.Name.includes("Nonconforming")?"DTI 45%  No RSU for ARM":""}</div>
            :
              <div style={{overflow:"hidden",width:"180px",fontSize: 16,color:"#222",whiteSpace:"nowrap", textOverflow:'ellipsis', lineHeight: '20px'}}>{record.Name}</div>
            }
            <ArmCadenceTag arm={record.Arm} />
            {/* <Row>{record.Name}</Row> */}
            {/* <Row style={{fontSize:"12px", color:"#6E6E70",marginTop:"5px"}}>{`Last Updated on ${getCurrentDate()} 09:00`}</Row> */}
          </div>
        </Tooltip>
      ),
      sorter:(a, b) => a.program.localeCompare(b.program),
      sortDirections: ['descend','ascend','descend'],
    },
    // {
    //   title: 'Product',
    //   dataIndex: 'name',
    //   key: 'product',
    //   width:"95px",
    //   render:(_,record)=>(
    //     <div>
    //       {/* <Row><strong>{com.divideStringByCapitalLetter(record.Lender)}</strong></Row> */}
    //       <div style={{fontSize:"12px",color:"#6E6E70",fontWeight:"400"}}>{record.Name}</div>
    //       {/* <Row style={{fontSize:"12px", color:"#6E6E70",marginTop:"5px"}}>{`Last Updated on ${getCurrentDate()} 09:00`}</Row> */}
    //     </div>
    //   ),
    // },
    {
      title: <Tooltip title="Interest rate/ Annual percentage rate">Rate/APR</Tooltip>,
      dataIndex: 'rate',
      key: 'rate',
      width:"100px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <>
          {!props.isCelebrity && <div style={{color:currentTarget==='rate' && record.isConnected ?"#1677FF":'#222', fontFamily: 'Inter', fontSize: 16, fontWeight: 600, lineHeight: '20px'}}>
            <div>{record.rate.toFixed(3)}%</div>
            <div className="table-gray-text">{record.APR.toFixed(3)}% APR</div>
          </div>}
          {props.isCelebrity && record.Name.includes("Nonconforming") && 
            <div style={{color:currentTarget==='rate' && record.isConnected ?"#1677FF":'#222', fontFamily: 'Inter', fontSize: 16, fontWeight: 600}}>
              <div>{record.rate.toFixed(3)}%</div>
              <div className="table-gray-text">{record.APR.toFixed(3)}% APR</div>
            </div>}
          {props.isCelebrity && !record.Name.includes("Nonconforming") && <>
            <div style={{color:currentTarget==='rate' && record.isConnected ?"#1677FF":'#222'}}>{getRatesAfterSpecials(record)}%</div>
            {<Popover 
              content={
                <div>
                  <div className="d-flex justify-content-between pl-2 pr-2 bold">
                    <div>Rate before specials:</div>
                    <div>{record.rate.toFixed(3)}%</div>
                  </div>
                  <div className="pl-2 pr-2" style={{color:"green"}}>
                    {Object.entries(props.specialAdjustments).map(([key,value])=>{
                      if (key !== 'Total') {
                        return (    
                            <div>{value}% for {key} special adjustment</div>
                        )
                      }
                    })}
                  </div>
                  <hr/>
                  <div className="d-flex justify-content-between pl-2 pr-2 bold" style={{color:"#ff2377"}}>
                    <div>Rate after specials:</div>
                    <div>{getRatesAfterSpecials(record)}%</div>
                  </div>
                </div>
              }
            >
              <div className="specialAdjustments">{"Specials detail"}</div>
            </Popover>
            }
          </>
          }
        </>
      ),
      sorter:(a, b) => {
          return a.rate - b.rate;
      },
      sortDirections: ['ascend','descend',"ascend"],
    },
    {
      title: <Tooltip title="The adjusted price is calculated by adding the price adjustment points to the lock day price..">
        {/*title="The adjusted price is calculated by adding the price adjustment points to the lock day price.">*/}
        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* <img src="/images/rates-price-icon.svg"/>  */}
          <span>Price</span>
        </div>
      </Tooltip>,
      dataIndex: 'originalprice',
      key: 'originalprice',
      width:"130px",
      className: "outerRateColumn",
      render:(_,record)=>{
        const pricing = getMaxPriceBreakdown(record);
        let adjustedPrice = useDiscountFormat ? formatPricePoints(pricing.afterCapPoints) +"%" : formatPricePoints(pricing.afterCapPrice)
        let tooltipContent = <div>Price: {adjustedPrice}（{formatPricePoints(0 - pricing.afterCapPoints)}%）</div>
        return <Tooltip title={tooltipContent} placement='bottom'>
          <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
            <div style={{ fontFamily: 'Inter', fontSize: 16, fontWeight: 600, color: !record.isConnected?"":pricing.afterCapPoints<=0 ? "#208029": "#C21818", lineHeight: '20px'}} >
              <div>{adjustedPrice}</div>
              <div className="table-gray-text">{formatAmount(pricing.afterCapAmount)}</div>
            </div> 
          </div>
        </Tooltip>

        // <Popover overlayClassName='total-pricing-popover' placement='bottomLeft' content={record.popoverContent} title=''>
        //   <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
        //     <div style={{ fontFamily: 'Inter', fontSize: 16, fontWeight: 600, color: !record.isConnected?"":record.originalprice<=0 ? "#208029": "#C21818", lineHeight: '20px'}} >
        //       <div>{adjustedPrice}</div>
        //       <div className="table-gray-text">${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}</div>
        //     </div> 
        //   </div>
        // </Popover>
      },
      sorter:(a, b) => getMaxPriceBreakdown(a).afterCapPoints - getMaxPriceBreakdown(b).afterCapPoints,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: <Tooltip title='Lender-paid compensation'>Comp.</Tooltip>,
      dataIndex: 'compensationprice',
      key: 'compensationprice',
      width:"110px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <div style={{ fontFamily: 'Inter', fontSize: 16, color: '#222',fontWeight: 600, lineHeight: '20px'}}>
          {record.isConnected ? 
            (props.searchParams.compensationType === 'lender_paid' ? 
              <>
                <div>{formatPricePoints(record.prices.compensationPoint)}</div>
                <div className="table-gray-text">{formatAmount(record.compensationprice)}</div>
              </> :
              <>
                <div>-</div>
                <div className="table-gray-text">paid at closing</div>
              </> 
             )
          : "---"}</div>
      ),
      sorter:(a, b) => a.compensationprice - b.compensationprice,
      sortDirections: ['descend','ascend','descend'],
    },

    {
      title: <Tooltip title='Net pricing after LLPA and compensation adjustments.'>Final price</Tooltip>,
      dataIndex: 'points',
      key: 'points',
      width:"120px",
      className: "outerRateColumn",
      render:(_,record)=>{
        const pricing = getNetPricingBreakdown(record);
        let p = useDiscountFormat ? formatPricePoints(pricing.points) + "%" : formatPricePoints(pricing.price)
        // useDiscountFormat ? parseFloat(record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points).toFixed(3) + "%" : parseFloat(100 - (record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points)).toFixed(3)
        let price = pricing.amount;
        // record.FHAMIP ? (record.lender_credit + record.FHAMIP.upfrontMIP) : record.lender_credit

        let tooltipContent = <div>Final price: {p}（{formatPricePoints(0 - pricing.points)}%）</div>
        // let tooltipContent = <div>Final price: {record.lender_credit < 0 ? p : adjustedPrice}（{0 - parseFloat(record.lender_credit < 0 ? (record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points) : record.originalprice).toFixed(3)}%）</div>
        return <>
          {record.isConnected? <div style={{ fontFamily: 'Inter'}}>
            <Tooltip title={tooltipContent} placement="bottom">
              <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
                <div style={{fontSize: 16, color: record.lender_credit<=0 ? "#208029":"#C21818", fontWeight: 600, lineHeight: '20px', marginBottom: '4px'}}>
                  { record.lender_credit < 0 ?
                    <>
                      <div>{p}</div>
                      <div className="table-gray-text">{formatAmount(price)}</div>
                    </> :
                    <>
                      <div>{p}</div>
                      <div className="table-gray-text">{formatAmount(price)}</div>
                      {/* <div>{adjustedPrice}</div>
                      <div className="table-gray-text">${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}</div> */}
                    </>
                  }
                </div>
              </div>
            </Tooltip>
            {/* <div style={{fontSize: 14, color:"#6E6E70", lineHeight: '18px'}}>Est. Closing cost: <span style={{fontWeight: 500}}>${com.commaizeFloat(Math.round(record.closing_cost))}</span></div> */}
          </div>
          :
          <Tooltip title="No lender-paid compensation applies; final price equals gross price (minus any program-required adjustments)." placement="bottom">
            <div>
              <div>{p}</div>
              <div className="table-gray-text">{formatAmount(price)}</div>
            </div>
          </Tooltip>
          }</>
        // <>
        //   {record.isConnected? <div style={{ fontFamily: 'Inter'}}>
        //     <Popover placement='bottomLeft' overlayClassName='total-pricing-popover' content={record.netpricingPopContent} title=''>
        //       <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
        //         <div style={{fontSize: 16, color: record.lender_credit<=0 ? "#208029":"#C21818", fontWeight: 600, lineHeight: '20px', marginBottom: '4px'}}>
        //           { record.lender_credit < 0 ?
        //             <>
        //               <div>{p}</div>
        //               <div className="table-gray-text">{"$"+com.commaizeFloat(price.toFixed(0))}</div>
        //             </> :
        //             <>
        //               <div>{adjustedPrice}</div>
        //               <div className="table-gray-text">${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}</div>
        //             </>
        //           }
        //         </div>
        //       </div>
        //     </Popover>
        //     {/* <div style={{fontSize: 14, color:"#6E6E70", lineHeight: '18px'}}>Est. Closing cost: <span style={{fontWeight: 500}}>${com.commaizeFloat(Math.round(record.closing_cost))}</span></div> */}
        //   </div>
        //   :
        //   <div>---</div>
        // }</>
      },
      sorter:(a, b) => {
        if (a.points !== b.points){
          return a.points - b.points;
        } else {
          return a.rate - b.rate;
        }
      },
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend','descend','ascend'],
    },
    {
      title: <Tooltip title="Estimated closing cost">Closing cost</Tooltip>,
      dataIndex: 'closingcost',
      key: 'closingcost',
      width:"120px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <div className="table-black-text">{formatAmount(Number(record.closing_cost))}</div>
      ),
      sorter:(a, b) => a.closing_cost - b.closing_cost,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: <Tooltip title="Monthly principal and interest payment.">PMT</Tooltip>,
      dataIndex: 'monthlypay',
      key: 'monthlypay',
      width:"90px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <div>
          <div style={{ fontFamily: 'Inter', color: '#222', fontSize: 16, fontWeight: 600, lineHeight: '20px', marginBottom: 4}}>${commaizeFloat(record.monthlypay)}</div>
          {record.isConnected && <div style={{fontSize: 14, fontFamily: 'Inter', color: com.divideStringByCapitalLetter(record.Lender) === "GMCC Celebrities" && record.dti.toFixed(0) > 45 ?"#C21818":"#6E6E70", lineHeight: '18px'}}>DTI: <span style={{ fontWeight: 500 }}>{record.dti.toFixed(0)}%</span></div>}
        </div>
      ),
      sorter:(a, b) => a.monthlypay - b.monthlypay,
      sortDirections: ['descend','ascend','descend'],
    },
    // {
    //   title: '',
    //   key: 'share',
    //   align: "center",
    //   width:"30px",
    //   render: (_, record) => (
    //     checkAccess([UR_Owner]) && !record.isConnected ? <div><img src="/images/priceengine/addLendersIcon.png" onClick={()=>setShowAddLendersModal(true)} style={{cursor: "pointer", width:32}} /></div> : ""
    //   ),
    // },
    Table.EXPAND_COLUMN,
  ];
  
  const innerColumns=[
    {
      title: <span style={{fontSize: 14, color: '#586570', fontWeight: 500, lineHeight: '24px'}}></span>,
      dataIndex: '',
      key: 'compare',
      width:"80px",
      className: "outerRateColumn",
      render: (_, record) => (
        <Checkbox
          checked={selectedRowKeys.includes(record.key)}
          onChange={() => handleSelectRow(record)}
        />
      ),
    },
    {
      title: 'Lender & Product',
      dataIndex: 'program',
      key: 'program',
      width:"135px",
      className: "outerRateColumn",
      render:(_,record)=>(
        <Tooltip
          overlayClassName='rates-lender-tooltip'
          arrow={false}
          placement="bottomLeft"
          title={
            <div>
              <div style={{fontFamily: 'Inter', fontSize:"16px", color:"#FFF", lineHeight: '20px'}}>{props.isCelebrity ? (record.Name.includes("Community Opportunity")?"No MI": record.Name.includes("Nonconforming")?"DTI 45%  No RSU for ARM":"") : record.Name}</div>
            </div>
          }
        >
          <div>
            <Row><div style={{fontSize:"16px", fontFamily: 'Inter', color: '#222', lineHeight: '20px', fontWeight: 500}}>{com.divideStringByCapitalLetter(record.Lender) === "GMCC Celebrities"?(record.Name.includes("Nonconforming")?"GMCC Celebrity Jumbo": record.Name.includes("Community Opportunity")?"GMCC Community Opportunity" : record.Name.includes("30 Year Conforming")? "GMCC Celebrity": "GMCC Celebrity FHA"):com.formatLenderDisplayName(record.Lender)}</div></Row>
            {props.isCelebrity && props.grantAvailable !== "None" && 
             <div className="grantInfoBulb">
              { props.grantAvailable === "10K"? "$10K Grant available" : props.grantAvailable === "5K"?"$5K Grant available":"$15K Grant available"}
             </div>}
            {props.isCelebrity ? 
              <div style={{overflow:"hidden",width:"180px",fontSize: 16,color:"#222",whiteSpace:"nowrap", textOverflow:'ellipsis', lineHeight: '20px'}}>{record.Name.includes("Community Opportunity")?"No MI": record.Name.includes("Nonconforming")?"DTI 45%  No RSU for ARM":""}</div>
            :
              <div style={{overflow:"hidden",width:"180px",fontSize: 16,color:"#222",whiteSpace:"nowrap", textOverflow:'ellipsis', lineHeight: '20px'}}>{record.Name}</div>
            }
            <ArmCadenceTag arm={record.Arm} />
            {/* <Row>{record.Name}</Row> */}
            {/* <Row style={{fontSize:"12px", color:"#6E6E70",marginTop:"5px"}}>{`Last Updated on ${getCurrentDate()} 09:00`}</Row> */}
          </div>
        </Tooltip>
      ),
      sorter:(a, b) => a.program.localeCompare(b.program),
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: 'Rate/APR',
      dataIndex: 'rate',
      key: 'rate',
      width:"100px",
      className: "innerRateColumn",
      sorter:(a, b) => a.rate - b.rate,
      sortDirections: ['descend','ascend','descend'],
      defaultSortOrder: 'ascend',
      render:(_,record)=>(
        <>
        {!props.isCelebrity && 
          <div style={{fontFamily: 'Inter', color: '#222', fontSize: 16, fontWeight: 600, lineHeight: '20px'}}>
            <div>{record.rate.toFixed(3)}%</div>
            <div className="table-gray-text">{record.APR.toFixed(3)}% APR</div>
          </div>
        }
        {props.isCelebrity && record.Name.includes("Nonconforming") && 
          <div style={{color:currentTarget==='rate' && record.isConnected ?"#1677FF":'', fontFamily: 'Inter', fontSize: 16, fontWeight: 600, lineHeight: '20px'}}>
              <div>{record.rate.toFixed(3)}%</div>
              <div className="table-gray-text">{record.APR.toFixed(3)}% APR</div>
          </div>
        }
        {props.isCelebrity && !record.Name.includes("Nonconforming") && <>
            <div style={{color:currentTarget==='rate' && record.isConnected ?"#1677FF":'', fontFamily: 'Inter', fontSize: 16, fontWeight: 600, lineHeight: '20px'}}>{getRatesAfterSpecials(record)}%</div>
            {<Popover 
              content={
                <div>
                  <div className="d-flex justify-content-between pl-2 pr-2 bold">
                    <div>Rate before specials:</div>
                    <div className="table-gray-text">{record.rate.toFixed(3)}% APR</div>
                  </div>
                  <div className="pl-2 pr-2" style={{color:"green"}}>
                    {Object.entries(props.specialAdjustments).map(([key,value])=>{
                      if (key !== 'Total') {
                        return (    
                            <div style={{display:record.Name.includes("Community") && key === "CRA"? "none": record.Name.includes("Wh_Cnf") && key==="Market"?"none":record.Name.includes("Community")&& key ==="Holiday"?"none":""}}>{value}% for {key} special adjustment</div>
                        )
                      }
                    })}
                  </div>
                  <hr/>
                  <div className="d-flex justify-content-between pl-2 pr-2 bold" style={{color:"#ff2377"}}>
                    <div>Rate after specials:</div>
                    <div>{getRatesAfterSpecials(record)}%</div>
                  </div>
                </div>
              }
            >
              <div className="specialAdjustments">{"Specials detail"}</div>
            </Popover>
            }
          </>
          }
        </>
      ),
    },
    // {
    //   title: 'DTI',
    //   dataIndex: 'dti',
    //   key: 'dti',
    //   width:"90px",
    //   className: "innerRateColumn",
    //   render:(_,record)=>(
    //     <div>
    //       <div style={{fontSize: 16, color: '#222', fontWeight: 500, lineHeight: '20px'}}>{record.dti.toFixed(0)}%</div>
    //     </div>
    //   ),
    // },
    {
      title: (
        <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {/* <img src="/images/rates-price-icon.svg"/>  */}
          <span>Price</span>
        </div>
      ),
      dataIndex: 'originalprice',
      key: 'originalprice',
      width:"135px",
      sorter:(a, b) => getMaxPriceBreakdown(a).afterCapPoints - getMaxPriceBreakdown(b).afterCapPoints,
      sortDirections: ['descend','ascend','descend'],
      className: "innerRateColumn",
      render:(_,record)=>{
        const pricing = getMaxPriceBreakdown(record);
        let adjustedPrice = useDiscountFormat ? formatPricePoints(pricing.afterCapPoints) +"%" : formatPricePoints(pricing.afterCapPrice)
        let tooltipContent = <div>Price: {adjustedPrice}（{formatPricePoints(0 - pricing.afterCapPoints)}%）</div>
        return <Tooltip title={tooltipContent} placement="bottom">
          <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
            <div style={{ fontFamily: 'Inter', fontSize: 16, fontWeight: 600, lineHeight: '20px', color: !record.isConnected?"": pricing.afterCapPoints<=0 ? "#208029": "#C21818"}} >
              <div>{adjustedPrice}</div>
              <div className="table-gray-text">{formatAmount(pricing.afterCapAmount)}</div>
            </div>
          </div>
        </Tooltip>
        // <Popover overlayClassName='total-pricing-popover' placement='bottomLeft' content={record.popoverContent} title=''>
            // <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
            //   <div style={{ fontFamily: 'Inter', fontSize: 16, fontWeight: 600, lineHeight: '20px', color: !record.isConnected?"": record.originalprice<=0 ? "#208029": "#C21818"}} >
            //     <div>{adjustedPrice}</div>
            //     <div className="table-gray-text">${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}</div>
            //   </div>
            // </div>
        // </Popover>
      },
    },
    {
      title: 'Comp.',
      dataIndex: 'compensationprice',
      key: 'compensationprice',
      width:"115px",
      className: "innerRateColumn",
      render:(_,record)=>(
        <div style={{ fontFamily: 'Inter', fontSize: 16, color: '#222',fontWeight: 600, lineHeight: '20px'}}>{
          record.isConnected ? 
            props.searchParams.compensationType === 'lender_paid' ? <><div>{formatPricePoints(record.prices.compensationPoint)}</div><div className="table-gray-text">{formatAmount(record.compensationprice)}</div></> : <><div>-</div><div className="table-gray-text">paid at closing</div></>
           : "---"}
        </div>
      ),
      sorter:(a, b) => a.compensationprice - b.compensationprice,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: <Tooltip title='The total price is the sum of the lock day price, adjustment points, and compensation points.'>Final price</Tooltip>,
      dataIndex: 'points',
      key: 'points',
      width:"130px",
      className: "innerRateColumn",
      render:(_,record)=>{
        const pricing = getNetPricingBreakdown(record);
        let p = useDiscountFormat ? formatPricePoints(pricing.points) + "%" : formatPricePoints(pricing.price)
        // let p = useDiscountFormat ? parseFloat(record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points).toFixed(3) + "%" : parseFloat(100 - (record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points)).toFixed(3)

        let price = pricing.amount
        // let price = record.FHAMIP ? (record.lender_credit + record.FHAMIP.upfrontMIP) : record.lender_credit

        let tooltipContent = <div>Final price: {p}（{formatPricePoints(0 - pricing.points)}%）</div>
        // let tooltipContent = <div>Final price: {record.lender_credit < 0 ? p : adjustedPrice}（{0 - parseFloat(record.lender_credit < 0 ? (record.FHAMIP ? record.points + (100*record.FHAMIP.upfrontMIP/record.loanAmount) : record.points) : record.originalprice).toFixed(3)}%）</div>
        return <>
          {record.isConnected?
          <Tooltip title={tooltipContent} placement="bottom">
              <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
              <div style={{fontFamily: 'Inter', fontSize: 16, fontWeight: 600, color: record.lender_credit<=0 ? "#208029":"#C21818", lineHeight: '20px'}}>
                {!record.isConnected ? "---" :  
                    record.lender_credit < 0 ?
                    <><div>{p}</div><div className="table-gray-text">{formatAmount(price)}</div></>
                    : 
                    <><div>{p}</div><div className="table-gray-text">{formatAmount(price)}</div></>
                    // <>
                    //   <div>{adjustedPrice}</div>
                    //   <div className="table-gray-text">${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}</div>
                    // </>
                }
              </div>
            </div>
          </Tooltip>
          :
          <Tooltip title="No lender-paid compensation applies; final price equals gross price (minus any program-required adjustments)." placement="bottom">
            <div>
              <div>{p}</div>
              <div className="table-gray-text">{formatAmount(price)}</div>
            </div>
          </Tooltip>
        }</>
        //   <>
        //   {record.isConnected?
        //     <Popover content={record.netpricingPopContent} title=''>
        //       <div style={{display:"flex",alignItems:"center"}} className="cursor-pointer">
        //       <div style={{fontFamily: 'Inter', fontSize: 16, fontWeight: 600, color: record.lender_credit<=0 ? "#208029":"#C21818", lineHeight: '20px'}}>
        //         {!record.isConnected ? "---" :  
        //             record.lender_credit < 0 ?
        //             <><div>{p}</div><div className="table-gray-text">$ { com.commaizeFloat(price.toFixed(0))}</div></>
        //             : 
        //             <>
        //               <div>{adjustedPrice}</div>
        //               <div className="table-gray-text">${commaizeFloat(parseFloat(record.originalprice * record.loanAmount*0.01).toFixed(0))}</div>
        //             </>
        //         }
        //       </div>
        //     </div>
        //   </Popover>
        //   :
        //   <div>---</div>
        // }</>
      },
      sorter:(a, b) => a.points - b.points,
      sortDirections: ['descend','ascend','descend'],
    },
    {
      title: 'Closing cost',
      dataIndex: 'compensationprice',
      key: 'compensationprice',
      width:"130px",
      sorter:(a, b) => a.originalprice - b.originalprice,
      sortDirections: ['descend','ascend','descend'],
      className: "innerRateColumn",
      render:(_,record)=>(
        <div style={{fontSize: 16,color:"#222",fontWeight: 600, lineHeight: '20px'}}>{formatAmount(record.closing_cost)}</div>
      ),
    },
    {
      title: 'PMT',
      dataIndex: 'monthlypay',
      key: 'monthlypay',
      width:"147px",
      className: "innerRateColumn",
      render:(_,record)=>(
        <div>
          <div style={{ fontFamily: 'Inter', color: '#222', fontSize: 16, fontWeight: 600, lineHeight: '20px'}}>${commaizeFloat(record.monthlypay)}</div>
          <div className="table-gray-text">{record.dti.toFixed(0)}%</div>
        </div>
      ),
    },
  ]

  const ineligiblecolumns = ineligibleColumns

  const calcTargetPricing = (rate) => {
    const data = rate.prices
    let target = 0
    const includesLockPoint = props.targetOptions.includes("lockpoint")
    const includesAdjustment = props.targetOptions.includes("adjustment")
    if (includesLockPoint) {
      target += data.lockDayPoint
    }
    if (includesAdjustment) {
      target +=  data.adjustmentPoint
    }
    // A Max Price cap applies to the combined pre-compensation price. Only
    // apply it when both components of that price are part of the target.
    if (includesLockPoint && includesAdjustment) {
      const pricing = getMaxPriceBreakdown(rate)
      target += pricing.afterCapPoints - pricing.beforeCapPoints
    }
    if (props.targetOptions.includes("compensation")) {
      target +=  data.compensationPoint
    }
    return parseFloat(target.toFixed(3))
  }

  let mtypes = [];
  let lenderSet = {}
  let lenderRates={}
  let lenderPrices={}
  let lenderRateRows={}
  let ineligibles = []
 
  for (let [name, value] of Object.entries(props.ineligibleProducts)) {
      ineligibles.push({
        Lender: name,
        ProductLevelReasons: value.ProductLevelReasons,
        LenderLevelReason: value.LenderLevelReason
      })
  }
  // console.log(ineligibles)
  
  for (let mtype in props.allRates) {
    for (let d of props.allRates[mtype]){
      let tmpname= d.Lender+' - '+d.Name
      if (typeof(lenderRates[tmpname]) === "undefined"){
        lenderRates[tmpname]=[]
        lenderPrices[tmpname]=[]
        lenderRateRows[tmpname]=[]
     
      }
      // for finding targeting price
      lenderRates[tmpname].push(d.base_rate);
      lenderPrices[tmpname].push(calcTargetPricing(d));
      lenderRateRows[tmpname].push(d);
    }
    mtypes.push(mtype)
    if (typeof lenderSet[mtype] === "undefined") {
      lenderSet[mtype] = new Set()
    }
    
    for (let d of props.allRates[mtype]) {
      lenderSet[mtype].add(d.Lender + "-" + d.Name);
    }
  }

  for (let m in lenderSet) {
    lenderSet[m] = Array.from(lenderSet[m]).sort((a, b) => {
      return a.toLowerCase().localeCompare(b.toLowerCase());
  })
  }

  const compareTarget=(target,targettype,pname,candidate)=>{
    const values = targettype === "rate" ? lenderRates[pname] : lenderPrices[pname]
    const rows = lenderRateRows[pname]
    if (!values || values.length === 0 || !rows) {
      return false
    }

    let minidx = 0
    let minDifference = Math.abs(values[0] - target)
    for (let i = 1; i < values.length; i++) {
      const difference = Math.abs(values[i] - target)
      if (difference < minDifference - 1e-9 ||
          (Math.abs(difference - minDifference) <= 1e-9 && rows[i].base_rate < rows[minidx].base_rate)) {
        minidx = i
        minDifference = difference
      }
    }
    // Compare the source object, rather than only rate/price values, so equal
    // values cannot promote multiple rows into the primary results table.
    return candidate === rows[minidx]
  }
  const showCompareModal = () => {
    if (selectedRowKeys.length > 0) {
      setCompareModal(true)
    }
  }
  const compareModalCancel = () => {
    setCompareModal(false)
  }
  const clearSelected = () => {
    setSelectedRowKeys([])
  }
  const cancelSelect = (key) => {
    setSelectedRowKeys((prevSelectedRowKeys) => 
      prevSelectedRowKeys.filter((item) => item !== key)
    )
  }
  const generateTableData = (ratesData, mtype,targettype) => {
    let tmpOuttableonRate = [];
    let tmpOuttableonPrice = [];
    let tmpIntable={}
    let idx=1;
    // console.log('generateTableData--------', ratesData, targettype)
    for (let d of ratesData){
      let mindiff=false
      let tmpname= d.Lender+' - '+d.Name
      let isConnected = (props.connectedLendersMap[d.Lender] && props.connectedLendersMap[d.Lender] === true )? true : false
      if(skipkeywords.includes(d.Mtype.toLowerCase())) {
        continue
      }
      
      // 添加 loanTypeFilter 过滤逻辑
      if (props.loanTypeFilter && props.loanTypeFilter.length > 0 && !props.loanTypeFilter.includes("")) {
        // 检查产品的贷款类型是否匹配 loanTypeFilter
        let productLoanType = "other";
        if(d.Mtype.includes("FHA")){
          productLoanType = "fha";
        }else if(d.Mtype.includes("VA")){
          productLoanType = "va";
        }else if(d.Mtype.includes("USDA")){
          productLoanType = "usda";
        }else if(d.Mtype.includes("CONFORMING")){
          productLoanType = "conventional";
        }
        
        // 如果产品的贷款类型不在过滤器中，则跳过
        if(!props.loanTypeFilter.includes(productLoanType)){
          continue;
        }
      }
      
      if (typeof(tmpIntable[tmpname]) === "undefined"){
        tmpIntable[tmpname]=[]
      }
      let adjs=[]
      for (let adj in d.Adjustments){
        let i = adjs.length
        adjs.push(
          <div className="d-flex justify-content-between price-calculation-item" style={{ color:"#6E6E70"}}>
            <div className="d-flex">
              <div style={{marginRight: 6, minWidth: 9}}>{i!=0?"+":""}</div>
              <div>{handleName(adj)}</div>
            </div>
            <div>{formatPricePoints(d.Adjustments[adj])}%</div>
          </div>
        )
      }
      const pricingBreakdown = getMaxPriceBreakdown(d)
      let originalprice = pricingBreakdown.afterCapPoints
      let Content=(
        <div className="adjusted-price-calculation-card">
          <div className="price-calculation-item-title">Adjusted price calculation</div>
          {adjs}
          <hr />
          <div className="d-flex justify-content-between price-calculation-item">
            <div style={{ marginLeft: 15 }}>Total adjustment points</div>
            <div>{formatPricePoints(d.prices.adjustmentPoint)}%</div>
          </div>
          <div className="d-flex justify-content-between price-calculation-item">
            <div><span style={{ marginRight: 6 }}>+</span>Lock day points</div>
            <div>{formatPricePoints(d.prices.lockDayPoint)}%</div>
          </div>
          {pricingBreakdown.hasMaxPriceCap && (
            <>
              <hr/>
              <div className="d-flex justify-content-between price-calculation-item">
                <div>Before Max Price</div>
                <div>{formatPricePoints(pricingBreakdown.beforeCapPrice)}</div>
              </div>
              <div className="d-flex justify-content-between price-calculation-item">
                <div>Max Price Cap</div>
                <div>{formatPricePoints(pricingBreakdown.capPoints)} pts</div>
              </div>
              <div className="d-flex justify-content-between price-calculation-item">
                <div>After Max Price</div>
                <div>{formatPricePoints(pricingBreakdown.afterCapPrice)}</div>
              </div>
            </>
          )}
          <hr/>
          <div className="d-flex justify-content-between price-calculation-item" style={{ color: '#222', fontWeight: 500 }}>
            <div>Total</div>
            <div>{formatPricePoints(originalprice)}%</div>
          </div>          
        </div>
      )

      let netpricingContent = (
        <div style={{padding:"15px 10px"}}>
          <div className="mb-4" style={{fontWeight:"500"}}>Net pricing Calculation:</div>
          <div>Total pricing: {formatPricePoints(originalprice)}% / {formatAmount(pricingBreakdown.afterCapAmount)}</div>
          {d.lender_credit < 0 &&
            <div>Compensation: {formatPricePoints(d.prices.compensationPoint)}% / {formatAmount(d.prices.compensationPoint * d.loanAmount * 0.01)}</div>
          }
          {d.FHAMIP !== undefined && <div>Upfront MIP: {100*d.FHAMIP.upfrontMIP/d.loanAmount}% / ${d.FHAMIP.upfrontMIP}</div>}
          <hr/>
          {d.lender_credit < 0 && <div>Net pricing: {formatPricePoints(d.FHAMIP !== undefined ? d.points + (100 * d.FHAMIP.upfrontMIP / d.loanAmount) : d.points)}% / {formatAmount(d.FHAMIP !== undefined ? d.points * d.loanAmount * 0.01 + d.FHAMIP.upfrontMIP : d.points * d.loanAmount * 0.01)}</div>}
          {d.lender_credit >= 0 && <div>
            Net pricing:  {d.FHAMIP !== undefined ? 
            formatPricePoints(originalprice + (100*d.FHAMIP.upfrontMIP/d.loanAmount)) :
            formatPricePoints(originalprice)}% / {formatAmount(d.FHAMIP !== undefined ?
              pricingBreakdown.afterCapAmount + d.FHAMIP.upfrontMIP :
              pricingBreakdown.afterCapAmount)}
          </div>}
        </div>
      )
      
      if(targettype==="rate" && compareTarget(targetrate,targettype,tmpname,d)){
        // console.log('targettype--------', targetrate, 'props: ' ,props.targetRate, d.base_rate, targettype, tmpname)
        tmpOuttableonRate.push({
          key:idx, 
          isConnected: isConnected,
          program:tmpname,
          rate: d.base_rate,
          price: Number(parseFloat(d.lender_credit).toFixed(2)),
          compensationprice: Number((d.prices.compensationPoint * d.loanAmount / 100).toFixed(2)),
          monthlypay: d.monthly_payment,
          dti: d.DTI,
          popoverContent:Content,
          netpricingPopContent:netpricingContent,
          fhamip: d.FHAMIP,
          pricedetails: d.prices,
          adjustments:d.Adjustments,
          ...d,
          originalprice: originalprice,
        })
        idx+=1;
        mindiff=true;
      }

      // 需要根据 searchParams.searchBy 区分是否是 rate
      if(targettype==="price" && compareTarget(100 - parseFloat(props.targetPrice),targettype,tmpname,d)){
        tmpOuttableonPrice.push({
          key:idx, 
          isConnected: isConnected,
          program:tmpname,
          rate: d.base_rate,
          price: Number(parseFloat(d.lender_credit).toFixed(2)),
          compensationprice: Number((d.prices.compensationPoint * d.loanAmount / 100).toFixed(2)),
          monthlypay: d.monthly_payment,
          dti: d.DTI,
          popoverContent:Content,
          netpricingPopContent:netpricingContent,
          fhamip: d.FHAMIP,
          pricedetails: d.prices,
          adjustments:d.Adjustments,
          ...d,
          originalprice: originalprice,
        })
        idx+=1;
        mindiff=true;
      }
      if (!mindiff) {
        tmpIntable[tmpname].push({
          program:tmpname,
          pricedetails: d.prices,
          isConnected: isConnected,
          rate: d.base_rate,
          price: Number(parseFloat(d.lender_credit).toFixed(2)),
          compensationprice: Number((d.prices.compensationPoint * d.loanAmount / 100).toFixed(2)),
          monthlypay:parseFloat(d.monthly_payment).toFixed(0),
          dti: d.DTI,
          popoverContent:Content,
          netpricingPopContent:netpricingContent,
          fhamip: d.FHAMIP,
          key: `${tmpname}_${d.base_rate}_${d.prices.lockDayPoint}`,
          ...d,
          originalprice: originalprice,
        })
      }
      
    }
    tmpOuttableonPrice = tmpOuttableonPrice.filter( d => {
      // 检查 selectedlenders 过滤
      const lenderMatch = props.selectedlenders.includes(d.program.split(" - ")[0]);
      // 检查 loanTypeFilter 过滤
      let loanTypeMatch = true;
      if (props.loanTypeFilter && props.loanTypeFilter.length > 0 && !props.loanTypeFilter.includes("")) {
        let productLoanType = "other";
        if(d.Mtype.includes("FHA")){
          productLoanType = "fha";
        }else if(d.Mtype.includes("VA")){
          productLoanType = "va";
        }else if(d.Mtype.includes("USDA")){
          productLoanType = "usda";
        }else if(d.Mtype.includes("CONFORMING")){
          productLoanType = "conventional";
        }
        loanTypeMatch = props.loanTypeFilter.includes(productLoanType);
      }
      return lenderMatch && loanTypeMatch;
    });
    tmpOuttableonPrice.sort((a,b)=>a.base_rate-b.base_rate);
    
    // 为 tmpOuttableonRate 也添加过滤逻辑
    tmpOuttableonRate = tmpOuttableonRate.filter( d => {
      // 检查 selectedlenders 过滤
      const lenderMatch = props.selectedlenders.includes(d.program.split(" - ")[0]);
      // 检查 loanTypeFilter 过滤
      let loanTypeMatch = true;
      if (props.loanTypeFilter && props.loanTypeFilter.length > 0 && !props.loanTypeFilter.includes("")) {
        let productLoanType = "other";
        if(d.Mtype.includes("FHA")){
          productLoanType = "fha";
        }else if(d.Mtype.includes("VA")){
          productLoanType = "va";
        }else if(d.Mtype.includes("USDA")){
          productLoanType = "usda";
        }else if(d.Mtype.includes("CONFORMING")){
          productLoanType = "conventional";
        }
        loanTypeMatch = props.loanTypeFilter.includes(productLoanType);
      }
      return lenderMatch && loanTypeMatch;
    });
    tmpOuttableonRate.sort((a,b)=>a.base_rate-b.base_rate);
    
    if (targettype==="rate"){
      return [tmpOuttableonRate,tmpIntable];
    }
    if (targettype==="price"){
      return [tmpOuttableonPrice,tmpIntable];
    }
  }
  
  let all={}
  let outdata={}
  let minRate=0;
  const tabdata=[];
  let idx=1;  
  
  let uncheckedProducts=["Agency","Jumbo","FHA","VA"];
  let checkedProducts=[];
  for(let p of props.stdproducts){
    checkedProducts.push(p)
    uncheckedProducts=uncheckedProducts.filter(e=>e!==p)
  }
  let skipkeywords=[]
  uncheckedProducts.map((key)=>{
    skipkeywords= skipkeywords.concat(skipKeywordsMap[key])
  })
  // console.log('---------xx', props.allRates)
  for(let mtype in props.allRates){
    [outdata[mtype],all[mtype]]=generateTableData(props.allRates[mtype],mtype,currentTarget);
    AllresultsCount[mtype]=outdata[mtype].length
    ConnectedresultsCount[mtype]=outdata[mtype].filter(d => d.isConnected).length
    if (outdata[mtype].length > 0) {
      minRate = outdata[mtype][0].base_rate
      // outdata[mtype]=[]
      all[mtype] = Object.fromEntries(
        Object.entries(all[mtype]).filter(([key, value]) => {
          // 首先检查 selectedlenders 过滤
          const lenderMatch = props.selectedlenders.includes(key.split(" - ")[0]);
          
          // 然后检查 loanTypeFilter 过滤
          let loanTypeMatch = true;
          if (props.loanTypeFilter && props.loanTypeFilter.length > 0 && !props.loanTypeFilter.includes("")) {
            // 从 value 数组中获取第一个产品来确定贷款类型
            if (value && value.length > 0) {
              const firstProduct = value[0];
              let productLoanType = "other";
              if(firstProduct.Mtype.includes("FHA")){
                productLoanType = "fha";
              }else if(firstProduct.Mtype.includes("VA")){
                productLoanType = "va";
              }else if(firstProduct.Mtype.includes("USDA")){
                productLoanType = "usda";
              }else if(firstProduct.Mtype.includes("CONFORMING")){
                productLoanType = "conventional";
              }
              loanTypeMatch = props.loanTypeFilter.includes(productLoanType);
            }
          }
          
          return lenderMatch && loanTypeMatch;
        })
      );
      // this part of code is to find the min rate of all lenders and show matched rates for all lenders
      // let indx = 1;
      // for (let key of Object.keys(all[mtype])){
      //   let d = all[mtype][key]
      //   let sample = d.find( ele => ele.rate === minRate)
      //   if (sample !== undefined){
      //     outdata[mtype].push({
      //       key:indx,
      //       ...sample
      //     })
      //   }
      //   else{
      //     let results = d.filter(ele => ele.rate > minRate)
      //     let minObj = results.reduce((min, obj)=> obj.rate < min.rate ? obj : min, results[0])
      //     outdata[mtype].push({
      //       key:indx,
      //       ...minObj
      //     })
      //   }
      //   indx+=1
      // }
      AllresultsCount[mtype]=outdata[mtype].length
      ConnectedresultsCount[mtype]=outdata[mtype].filter(d => d.isConnected).length
    }
    tabdata.push({
      tabTitle:typemap[mtype],
      intabledata: all[mtype],
      outtabledata:outdata[mtype],
      tabkey:mtype
    })
    idx+=1
  }

  const targetKey = TERM_TO_BUCKET[props.loanterm] || props.loanterm;
  let targetTab = tabdata.find(tab=>tab.tabkey===targetKey)
    || tabdata.find(tab=>(tab.outtabledata || []).length > 0)
    || tabdata[0]
    || { tabTitle: "", intabledata: [], outtabledata: [], tabkey: targetKey };
  // console.log("eligible targetTable data--------", targetTab)
  if (props.isCelebrity && !props.checkCelebrityLendingArea) {
    targetTab.outtabledata = []
    ineligibles = []
    ineligibles.push({
      Lender: "GMCC Celebrities",
      ProductLevelReasons: [],
      LenderLevelReason: "Subject property address is not in lending area."
    })
    ineligibles.push({
      Lender: "GMCC Celebrity CRA Community Opportunity",
      ProductLevelReasons: [],
      LenderLevelReason: "Subject property address is not in lending area."
    })
  }
  let termMap = {
    fixed40:"40 Year",
    fixed30:"30 Year",
    fixed25:"25 Year",
    fixed20:"20 Year",
    fixed15:"15 Year",
    fixed10:"10 Year",
    arm31:"3/1 ARM",
    arm36:"3/6 ARM",
    arm51:"5/1 ARM",
    arm56:"5/6 ARM",
    arm71:"7/1 ARM",
    arm76:"7/6 ARM",
    arm101:"10/1 ARM",
    arm106:"10/6 ARM",
    arm3:"ARM 3 Year",
    arm5:"ARM 5 Year",
    arm7:"ARM 7 Year",
    arm10:"ARM 10 Year",
  }
  const tabItems = [
    {
      key: "eligible",
      label: () => {
        return (
          <div className="cursor-pointer">
            {props.eligibleTabLabel || "Eligible QM"}{" "}
            <span
              className={
                "rates-tab-count " + (eligibilityView === "eligible" ? "active_tab_counts" : "inactive_tab_counts")
              }
            >
              {targetTab.outtabledata.length || 0}
            </span>
          </div>
        );
      },
    },
    {
      key: "ineligible",
      label: () => {
        return (
          <div cursor-pointer>
            {props.ineligibleTabLabel || "Ineligible"}{" "}
            <span
              className={
                "rates-tab-count " + (eligibilityView === "ineligible" ? "active_tab_counts" : "inactive_tab_counts")
              }
            >
              {ineligibles.length || 0}
            </span>
          </div>
        );
      },
    },
  ];
  const onTabChange = (key) => {
    if (props.statsigSource === 'rates' && key !== eligibilityView) {
      const tab = key === 'ineligible' ? 'ineligibles' : 'eligibles'
      track(STATSIG.RATES.RESULT_TAB, tab, { type: tab })
    }
    setEligibilityView(key);
  };
  const handleDownloadRateSheet = (e, record) => {
    // FileInfo is only populated when the rates request sets getFiles: true (and
    // the calc can still fail per lender) -- guard so a missing URL never opens
    // a blank tab.
    if (!record.FileInfo || !record.FileInfo.TermsUrl) return;
    if (props.statsigSource === 'rates') {
      track(STATSIG.RATES.DOWNLOAD_RATE_SHEET_BUTTON)
    }
    window.open(record.FileInfo.TermsUrl, '_blank');
  }
  const getMergedDetail = (record) => {
    // 取出两个来源
    const cardDetail = record.closing_costs_detail || record.estimatedclosingcosts?.closingCostsDetail || {};
    const propDetail = props.appliedClosingCostsDetail || {};
    // 需要合并的所有字段
    const fields = [
        'canNotShopServices',
        'canShopServices',
        'taxesAndOtherGovernmentFees',
        'originationCharges',
        'prepaids',
        'initialEscrowPaymentsAtClosing',
        'other'
    ];

    const isValidCost = item => item && typeof item.serviceName === 'string' && item.serviceName.trim() !== '';
    // 合并逻辑：同名字段合并为一个数组，并兼容历史空名称配置
    const merged = {};
    fields.forEach(field => {
        const arr1 = Array.isArray(cardDetail[field]) ? cardDetail[field] : [];
        const arr2 = Array.isArray(propDetail[field]) ? propDetail[field] : [];
        merged[field] = [...arr1, ...arr2].filter(isValidCost);
    });

    return merged;
}
  const getClosingCostDetails = (record) => {
    const detail = getMergedDetail(record);
    if (!detail) return null;

    // 计算各项费用总和
    const calculateTotal = (items) => {
        if (!Array.isArray(items)) return 0;
        return items.reduce((sum, item) => sum + parseFloat(item.estimateAmount || 0), 0);
    };

    // 计算各项费用
    const originationCharges = calculateTotal(detail.originationCharges);
    const cantShopForServices = calculateTotal(detail.canNotShopServices);
    const canShopForServices = calculateTotal(detail.canShopServices);
    const taxesAndFees = calculateTotal(detail.taxesAndOtherGovernmentFees);
    const prepaids = calculateTotal(detail.prepaids);
    const initialEscrow = calculateTotal(detail.initialEscrowPaymentsAtClosing);
    const otherFees = calculateTotal(detail.other);

    // 计算总贷款成本
    const totalLoanCosts = originationCharges + cantShopForServices + canShopForServices;
    
    // 计算其他总成本
    const totalOtherCosts = taxesAndFees + prepaids + initialEscrow + otherFees;

    // 贷款人积分 - 直接使用 lender_credit
    const lenderCredits = parseFloat((record.lender_credit || 0).toFixed(2));
    
    // 计算总成交成本
    const totalClosingCosts = parseFloat((totalLoanCosts + totalOtherCosts + (lenderCredits < 0 ? lenderCredits : 0))); // lenderCredits is negative

    const mip = record.closing_costs_detail?.canNotShopServices?.find(item => item.serviceName === "Upfront Mortgage Insurance Premium")?.estimateAmount || 0

    const estimaTedCashToCost = parseFloat((props.searchParams.purpose === 'Purchase' ? props.searchParams.downPayment : 0) - mip + totalClosingCosts); // totalClosingCosts is negative

    return {
        originationCharges: originationCharges.toFixed(2),
        canShopForServices: canShopForServices.toFixed(2),
        cantShopForServices: cantShopForServices.toFixed(2),
        totalLoanCosts: totalLoanCosts.toFixed(2),
        taxesAndFees: taxesAndFees.toFixed(2),
        prepaids: prepaids.toFixed(2),
        initialEscrow: initialEscrow.toFixed(2),
        otherFees: otherFees.toFixed(2),
        totalOtherCosts: totalOtherCosts.toFixed(2),
        lenderCredits: lenderCredits,
        totalClosingCosts: Number(totalClosingCosts.toFixed(2)),
        estimaTedCashToCost: Number(estimaTedCashToCost.toFixed(2))
    };
  };
  const adjustment_svg = (data) => {
    const isPositive = Number(data) > 0;
    const str = isPositive ? `Positive Value (+)
This means the borrower is paying points to get a lower interest rate. These costs show up in Section A: Origination Charges.` : `Negative Value (–)
This means the borrower is getting a lender credit for choosing a higher interest rate. You'll see this credit reflected in Section J: Lender Credits of the Loan Estimate.`
    return (
      <span className="cursor-pointer">
      <Tooltip title={str}>
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9 15.1607C12.4025 15.1607 15.1607 12.4025 15.1607 9C15.1607 5.59753 12.4025 2.83929 9 2.83929C5.59753 2.83929 2.83929 5.59753 2.83929 9C2.83929 12.4025 5.59753 15.1607 9 15.1607ZM9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z" fill="#6E6E70"/>
        <path d="M10.0714 5.78571C10.0714 6.37745 9.59173 6.85714 9 6.85714C8.40827 6.85714 7.92857 6.37745 7.92857 5.78571C7.92857 5.19398 8.40827 4.71429 9 4.71429C9.59173 4.71429 10.0714 5.19398 10.0714 5.78571Z" fill="#6E6E70"/>
          <path d="M8.19643 7.92857H9.80357V13.2857H8.19643V7.92857Z" fill="#6E6E70"/>
        </svg>
      </Tooltip>
      </span>
    )
  }
  const handleViewFeeSheet = (e, record) => {
    // console.log("view fee sheet record--------",record)
    if(record !== null){
      if (props.statsigSource === 'rates') {
        track(STATSIG.RATES.VIEW_FEE_SHEET_BUTTON, 'preview', { type: 'preview' })
      }
      setCurrentRecord({...record, compensationType: props.searchParams.compensationType})
      setShowClosingCostDetailModal(true)
    }
  }

  const formateDate = (date) => {
    // Last updated: 24 hours ago
    // Last updated: 2 days ago
    // 按照以上格式计算
    const now = new Date();
    const diffTime = Math.abs(now - new Date(date));
    const diffHours = Math.round(diffTime / (1000 * 60 * 60));
    if(diffHours === 0){
      return 'Last updated: just now';
    }
    if(diffHours === 1){
      return 'Last updated: 1 hour ago';
    }
    if(diffHours < 24){
      return `Last updated: ${diffHours} hours ago`;
    }
    if(diffHours < 48){
      return 'Last updated: 1 day ago';
    }else{
      return `Last updated: ${Math.round(diffTime / (1000 * 60 * 60 * 24))} days ago`;
    }
  }

  const row_detail =(record) => {
    // console.log("row detail record--------", record)
    const costs = getClosingCostDetails(record);
    let adjustments = [];
    for(let key in record.Adjustments){
      adjustments.push({
        name: key === "LoanBalanceCLTVAdjustment" ||
          (key === "LoanSizeCLTVAdjustment" && String(record.Name || "").includes("HELOC"))
          ? "Loan Balance CLTV Adjustment"
          : handleName(key),
        points: record.Adjustments[key],
        amount: record.Adjustments[key] * record.loanAmount / 100,
      })
    }
    const pricingBreakdown = getMaxPriceBreakdown(record)
    const netPricing = getNetPricingBreakdown(record)
    const totalAmount = () => Number(netPricing.amount.toFixed(2))
    const totalLLPA_and_base = () => {
      return formatPricePoints(pricingBreakdown.afterCapPrice)
    }
    const totalLLPAAmount_and_base = () => {
      return Number(pricingBreakdown.afterCapAmount.toFixed(2))
    }
    const totalPricing = () =>{
      return formatPricePoints(netPricing.price);
    }

    return (
      <div style={{display: 'flex', gap: 24}}>
        <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
          <div className="raw-detail-card" style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
            <div className="raw-detail-card-title" style={{marginBottom: 24}}>Adjustments</div>
            <div className="raw-detail-card-content-row-adjustments" style={{ marginBottom: 18, paddingBottom: 8}}>
              <div className="first-column label1">Factor</div>
              <div className="label1">Rate</div>
              <div className="label1">Price/Pts</div>
              <div className="label1">Amount</div>
            </div>
            <div className="raw-detail-card-content-row-adjustments" style={{borderBottom: '1px solid #dbdcde', marginBottom: 31, paddingBottom: 8}}>
              <div className="first-column label3">Base(lock day:{record.lockDay})</div>
              <div className="value label3">{Number(record.base_rate).toFixed(3)}%</div>
              <div className={Number(record.prices.lockDayPoint) > 0 ? "value_positive" : "value_negative"}>{formatPricePoints(100 - Number(record.prices.lockDayPoint))}</div>
              <div className="value">{formatAmount((record.loanAmount * Number(record.prices.lockDayPoint) / 100).toFixed(2))}</div>
            </div>
            <div className="raw-detail-card-content-row-adjustments" style={{marginBottom: 18}}>
              <div className="label3">Pricing adjustments</div>
            </div>
            {adjustments.map(item => {
              return (
                <div className="raw-detail-card-content-row-adjustments" style={{ paddingBottom: 18}}>
                  <div className="first-column label2">{item.name}</div>
                  <div className="value">-</div>
                  <div className={item.points > 0 ? "value_positive" : (item.points < 0 ? "value_negative" : "value")}>{Number.isFinite(Number(item.points)) ? formatPricePoints(Math.abs(Number(item.points))) : '-'}</div>
                  <div className="value">{Number(item.amount) === 0 ? '$0.00' : formatAmount(item.amount)}</div>
                </div>
              )
            })}
            <div className="raw-detail-card-content-row-adjustments" style={{borderTop: '1px solid #dbdcde', borderBottom: pricingBreakdown.hasMaxPriceCap ? undefined : '1px solid #dbdcde', padding: '12px 0px', marginBottom: pricingBreakdown.hasMaxPriceCap ? 0 : (props.searchParams.compensationType !== "lender_paid" ? 12 : 0)}}>
              <div className="first-column label3">{pricingBreakdown.hasMaxPriceCap ? 'Before Max Price' : 'Price'}</div>
                <>
                  <div className="value label3">-</div>
                  <div className={pricingBreakdown.beforeCapPrice < 100 ? "value_positive" : "value_negative"}>{formatPricePoints(pricingBreakdown.beforeCapPrice)}</div>
                  <div className="value">{formatAmount(pricingBreakdown.beforeCapAmount)}</div>
                </>
            </div>
            {pricingBreakdown.hasMaxPriceCap && <>
              <div className="raw-detail-card-content-row-adjustments" style={{padding: '12px 0px'}}>
                <div className="first-column label3">Max Price Cap</div>
                <div className="value">-</div>
                <div className="value">{formatPricePoints(pricingBreakdown.capPoints)}</div>
                <div className="value">{formatAmount(pricingBreakdown.capAmount)}</div>
              </div>
              <div className="raw-detail-card-content-row-adjustments" style={{borderBottom: '1px solid #dbdcde', padding: '12px 0px', marginBottom: props.searchParams.compensationType !== "lender_paid" ? 12 : 0}}>
                <div className="first-column label3">After Max Price</div>
                <div className="value">-</div>
                <div className={pricingBreakdown.afterCapPrice < 100 ? "value_positive" : "value_negative"}>{totalLLPA_and_base()}</div>
                <div className="value">{formatAmount(totalLLPAAmount_and_base())}</div>
              </div>
            </>}
            {props.searchParams.compensationType === "lender_paid" &&
            <div className="raw-detail-card-content-row-adjustments" style={{borderBottom: '1px solid #dbdcde', marginBottom: 12, padding: '12px 0px'}}>
              { props.searchParams.compensationType === "lender_paid" &&
                (
                  <>
                    {record.isConnected ? <>
                      <div className="first-column label3">Comp (Lender paid)</div>
                      <div className="value">-</div>
                      <div className={record.prices.compensationPoint > 0 ? "value_positive" : "value_negative"}>{record.prices.compensationPoint ? formatPricePoints(-record.prices.compensationPoint) :  '-'}</div>
                      <div className="value">{formatAmount(Number(record.compensationprice))}</div>
                    </> : <Tooltip title="No lender-paid compensation applies." placement="bottom">
                      <div style={{display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer'}}>
                        <div className="first-column label3 flex1">Comp (Lender paid)</div> 
                        <div className="value flex1">-</div>
                        <div className="value flex1">-</div>
                        <div className="value flex1">-</div>
                      </div>
                    </Tooltip>
                    }

                  </>
                )
              }
              {/* { props.searchParams.compensationType === "borrower_paid" &&
                (
                  <>
                    <div className="value">-</div>
                    <div className="value">-</div>
                    <div className="value">paid at closing</div>
                  </>
                )
              } */}
            </div>}
            {record.prices.closeOverPoint ?
            <div className="raw-detail-card-content-row-adjustments" style={{borderBottom: '1px solid #dbdcde', marginBottom: 24, padding: '9px 0px'}}>
              { record.prices.closeOverPoint &&
                (
                  <>
                    {
                      record.isConnected ? <>
                        <div className="first-column label3">Close Over Point</div>
                        <div className="value">-</div>
                        <div className={record.prices.closeOverPoint > 0 ? "value_positive" : "value_negative"}>{record.prices.closeOverPoint ? formatPricePoints(record.prices.closeOverPoint) :  '-'}</div>
                        <div className="value">{formatAmount(record.prices.closeOverPoint * record.loanAmount / 100)}</div>
                      </> : <Tooltip title="No close over point applies." placement="bottom">
                        <div style={{display: 'flex', alignItems: 'center', width: '100%', cursor: 'pointer'}}> 
                          <div className="first-column label3 flex1">Close Over Point</div>
                          <div className="value flex1">-</div>
                          <div className="value flex1">-</div>
                          <div className="value flex1">-</div>
                        </div>
                      </Tooltip>
                    }
                  </>
                )
              }
            </div> : <></>}
            {/* {record.FHAMIP !== undefined && 
            <div className="raw-detail-card-content-row-adjustments" style={{borderBottom: '1px solid #dbdcde', marginBottom: 26, paddingBottom: 19}}>
              <div className="first-column label1">Upfront MIP:</div>
                <>
                  <div className="value">-</div>
                  <div className={mip() > 0 ? "value_positive" : "value_negative"}>{mip()}</div>
                  <div className="value">{formatAmount(record.FHAMIP.upfrontMIP)}</div>
                </>
            </div>
            } */}
            {record.isConnected && <div className="raw-detail-card-content-row-adjustments">
              <div className="first-column label3">Final price</div>
              <div className="value label3">{record.base_rate ? Number(record.base_rate).toFixed(3) : '-'}%</div>
              <div className={totalPricing() < 100 ? "value_positive" : "value_negative"}>{totalPricing() ? totalPricing() :  '-'}</div>
              <div className="value" style={{display: 'flex', alignItems: 'center', flexDirection: 'row-reverse'}}>
                {/* {adjustment_svg(totalAmount())} */}
                <span style={{marginRight: 4}}>{formatAmount(totalAmount())}</span>
              </div>
            </div>}
            {!record.isConnected && 
              // <Tooltip title="No lender-paid compensation applies; final price = gross price minus program-required adjustments." placement="bottom">
                <div className="raw-detail-card-content-row-adjustments cursor-pointer">
                  <div className="first-column label3">Final price</div>
                  <div className="value label3">{record.base_rate ? Number(record.base_rate).toFixed(3) : '-'}%</div>
                  <div className={netPricing.price < 100 ? "value_positive" : "value_negative"}>{formatPricePoints(netPricing.price)}</div>
                    <div className="value" style={{display: 'flex', alignItems: 'center', flexDirection: 'row-reverse'}}>
                      {/* {adjustment_svg(totalLLPAAmount_and_base())} */}
                      <span style={{marginRight: 4}}>{formatAmount(netPricing.amount)}</span>
                    </div>
                </div>
              // </Tooltip>
            }
            <div className="raw-detail-card-content-row-adjustments" style={{flex: 1, minHeight: 24} }></div>
            <div className="raw-detail-card-content-row-adjustments" style={{}}>
              {/* <div className="raw-detail-card-content-download-title">Download links</div> */}
              <div className="raw-detail-card-content-download-row-item" style={{marginTop: 0, width: '100%'}}>
                <div className={record.FileInfo && record.FileInfo.TermsUrl ? "raw-detail-card-content-download-label cursor-pointer" : "raw-detail-card-content-download-label"} style={record.FileInfo && record.FileInfo.TermsUrl ? undefined : {opacity: 0.5}} onClick={(e) => handleDownloadRateSheet(e, record)}>
                  Download rate sheet
                </div>
                <div className="raw-detail-card-content-download-value" style={{textAlign: 'right'}}>
                  {/* A Go zero time ("0001-01-01...") means the backend never
                      resolved the file -- show '-' instead of "739,813 days ago". */}
                  {record.FileInfo && record.FileInfo.UpdatedAt && !record.FileInfo.UpdatedAt.startsWith('0001') ? formateDate(record.FileInfo.UpdatedAt) : '-'}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style={{flex: 1, display: 'flex', flexDirection: 'column'}}>
          <div className="raw-detail-card" style={{flex: 1}}>
            <div className="raw-detail-card-title"><span>Closing cost details</span> <span className="closing-cost-details-view-fee-sheet cursor-pointer" onClick={(e) => handleViewFeeSheet(e, record)}>View fee sheet</span></div>

            <div className="raw-detail-card-content-type">Loan costs</div>
            <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label">A. Origination Charges</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.originationCharges)}</div>
            </div>
            <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label">B. Services CANNOT shop for</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.cantShopForServices)}</div>
            </div>
            <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label">C. Services CAN shop for</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.canShopForServices)}</div>
            </div>
            <div className="raw-detail-card-content-row" style={{ borderTop: '1px solid #cfd4d9', paddingTop: 12 }}>
              <div className="raw-detail-card-content-label">D. Total Loan costs (A+B+C)</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.totalLoanCosts)}</div>
            </div>

            <div className="raw-detail-card-content-type">Other costs</div>
            <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label">E. Taxes & government fees</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.taxesAndFees)}</div>
            </div>
            <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label">F. Prepaids</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.prepaids)}</div>
            </div>
            <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label">G. Initial Escrow payments at closing</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.initialEscrow)}</div>
            </div>
            <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label">H. Others</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.otherFees)}</div>
            </div>
            <div className="raw-detail-card-content-row" style={{ borderTop: '1px solid #cfd4d9', paddingTop: 12 }}>
              <div className="raw-detail-card-content-label">I. Total Other costs (E+F+G+H)</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.totalOtherCosts)}</div>
            </div>
            <div className="raw-detail-card-content-row" style={{ borderTop: '1px solid #cfd4d9', paddingTop: 12 }}>
              <div className="raw-detail-card-content-label">J.Total closing cost (D+I+Lender credits)</div>
              <div className="raw-detail-card-content-value">{formatAmount(costs.totalClosingCosts)}</div>
            </div>
            {/* <div className="raw-detail-card-content-row">
              <div className="raw-detail-card-content-label" style={{marginLeft: 24}}>Lender credits</div>
              <div className="raw-detail-card-content-value">$ {commaizeFloat(costs.lenderCredits)}</div>
            </div> */}
            
            <div className="raw-detail-card-content-total">
              <div className="raw-detail-card-content-total-label">Cash to close</div>
              <div className="raw-detail-card-content-total-label">{formatAmount(costs.estimaTedCashToCost)}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const compare_svg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.5085 3.12562C11.7607 3.2301 11.9252 3.47623 11.9252 3.74924V4.57424H12.0002C13.2014 4.57424 14.1752 5.54803 14.1752 6.74924V9.9025C15.4652 10.2072 16.4252 11.3661 16.4252 12.7492C16.4252 14.3647 15.1157 15.6742 13.5002 15.6742C11.8847 15.6742 10.5752 14.3647 10.5752 12.7492C10.5752 11.3661 11.5352 10.2072 12.8252 9.9025V6.74924C12.8252 6.2936 12.4558 5.92424 12.0002 5.92424H11.9252V6.74924C11.9252 7.02225 11.7607 7.26838 11.5085 7.37286C11.2563 7.47733 10.9659 7.41958 10.7729 7.22654L9.2729 5.72654C9.00929 5.46293 9.00929 5.03555 9.2729 4.77194L10.7729 3.27194C10.9659 3.07889 11.2563 3.02114 11.5085 3.12562ZM13.5002 11.1742C12.6303 11.1742 11.9252 11.8794 11.9252 12.7492C11.9252 13.6191 12.6303 14.3242 13.5002 14.3242C14.3701 14.3242 15.0752 13.6191 15.0752 12.7492C15.0752 11.8794 14.3701 11.1742 13.5002 11.1742Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M1.5752 5.99922C1.5752 4.38379 2.88477 3.07422 4.5002 3.07422C6.11562 3.07422 7.42519 4.38379 7.42519 5.99922C7.42519 7.38233 6.46521 8.54122 5.17519 8.84595V11.9992C5.17519 12.4549 5.54455 12.8242 6.00019 12.8242H6.07519V11.9992C6.07519 11.7262 6.23965 11.4801 6.49188 11.3756C6.74411 11.2711 7.03444 11.3289 7.22749 11.5219L8.72749 13.0219C8.9911 13.2855 8.9911 13.7129 8.72749 13.9765L7.22749 15.4765C7.03444 15.6696 6.74411 15.7273 6.49188 15.6228C6.23965 15.5184 6.07519 15.2722 6.07519 14.9992V14.1742H6.00019C4.79898 14.1742 3.8252 13.2005 3.8252 11.9992V8.84595C2.53518 8.54122 1.5752 7.38233 1.5752 5.99922ZM4.5002 4.42422C3.63035 4.42422 2.9252 5.12937 2.9252 5.99922C2.9252 6.86906 3.63035 7.57422 4.5002 7.57422C5.37004 7.57422 6.07519 6.86906 6.07519 5.99922C6.07519 5.12937 5.37004 4.42422 4.5002 4.42422Z"
          fill="white"
        />
      </svg>
    );
  };
  return (
    <div className="text-left w-100" style={{height:"90%"}}>
      <div className="d-flex justify-content-end  align-items-center my-2" >
        {selectedRows.length >0 && <Button type="primary" className="mr-2" onClick={()=>setShowShareRatesModal(true)}>Share</Button>}
      </div>
      <div className="compare-rates">
        <div className="custom-tabs">
          {tabItems.map((item) => (
            <div
              key={item.key}
              className={`custom-tab-item ${
                eligibilityView === item.key ? "active" : ""
              }`}
              onClick={() => onTabChange(item.key)}
            >
              {item.label()}
            </div>
          ))}
        </div>
        <div className="rate-select-count"><div className="select-count">{selectedRowKeys.length} selected</div>{selectedRowKeys.length > 0 && <div className="clear-btn" onClick={clearSelected}>Clear</div>}</div>
        <div className="compare-rates-line"></div>
        <div className={`cursor-pointer search-results-result-header-right-box-compare-label ${
                selectedRowKeys.length > 0
                  ? "active_compare"
                  : "inactive_compare"
              }`}
             onClick={showCompareModal}>{compare_svg()}Compare</div>
      </div>
      {eligibilityView === "ineligible"?
        <Table
          style={{width:"100%"}}
          className="ineligibletable rates-page-table full-table rates-page-table-new"
          pagination={false}
          columns={ineligiblecolumns}
          rowClassName="ineligibleRow"
          dataSource={ineligibles}
          locale={{emptyText: <div style={{color:"#6E6E70"}}>{'No matched reason'}</div>}}
          scroll={{
            y: checkAccess((UR_PriceEngineUser)) ? props.viewportH- 440 : props.viewportH*0.55
          }}
        />
      :
        props.loading ? (<Table
          // style={{width:"100%"}}
          className="outertable rates-page-table rates-page-table-new"
          dataSource={[]}
          pagination={false}
          locale={{
            emptyText: 
              props.isCelebrity && !props.checkCelebrityLendingArea?
              <>
              <div style={{color:"#6E6E70", fontSize:"16px", fontWeight:"500"}}>
                Subject property address is not in lending area.
              </div>
              <Button className="backToSearch" onClick={() => props.setShowForm(true)}>Back to Search</Button>
              </>
              :
              <div style={{color:"#6E6E70"}}>
                No matched product found
              </div>
          }}
          columns={maincolumns}
          scroll={{
            y: checkAccess((UR_PriceEngineUser)) ? props.viewportH- 280 : props.viewportH*0.65,
            x: 'max-content'
          }}
          rowClassName={(record,_)=> record.isConnected ? "connectedLenderRow":"unconnectedLenderRow"}
          showSorterTooltip={false}
          
        />) : 
        (<Table
          // style={{width:"100%"}}
          className="outertable rates-page-table rates-page-table-new"
          style={{height: props.viewportH * 0.595}}
          dataSource={props.showConnectedLendersOnly ? 
            targetTab.outtabledata.filter(d => {
              // 检查连接状态
              const connectedMatch = d.isConnected;
              // 检查 selectedlenders 过滤
              const lenderMatch = props.selectedlenders.includes(d.program.split(" - ")[0]);
              // 检查 loanTypeFilter 过滤
              let loanTypeMatch = true;
              if (props.loanTypeFilter && props.loanTypeFilter.length > 0 && !props.loanTypeFilter.includes("")) {
                let productLoanType = "other";
                if(d.Mtype.includes("FHA")){
                  productLoanType = "fha";
                }else if(d.Mtype.includes("VA")){
                  productLoanType = "va";
                }else if(d.Mtype.includes("USDA")){
                  productLoanType = "usda";
                }else if(d.Mtype.includes("CONFORMING")){
                  productLoanType = "conventional";
                }
                loanTypeMatch = props.loanTypeFilter.includes(productLoanType);
              }
              return connectedMatch && lenderMatch && loanTypeMatch;
            }) : 
            targetTab.outtabledata.filter(d => {
              // 检查 selectedlenders 过滤
              const lenderMatch = props.selectedlenders.includes(d.program.split(" - ")[0]);
              // 检查 loanTypeFilter 过滤
              let loanTypeMatch = true;
              if (props.loanTypeFilter && props.loanTypeFilter.length > 0 && !props.loanTypeFilter.includes("")) {
                let productLoanType = "other";
                if(d.Mtype.includes("FHA")){
                  productLoanType = "fha";
                }else if(d.Mtype.includes("VA")){
                  productLoanType = "va";
                }else if(d.Mtype.includes("USDA")){
                  productLoanType = "usda";
                }else if(d.Mtype.includes("CONFORMING")){
                  productLoanType = "conventional";
                }
                loanTypeMatch = props.loanTypeFilter.includes(productLoanType);
              }
              return lenderMatch && loanTypeMatch;
            })
          }
          pagination={false}
          locale={{
            emptyText: 
              props.isCelebrity && !props.checkCelebrityLendingArea?
              <>
              <div style={{color:"#6E6E70", fontSize:"16px", fontWeight:"500"}}>
                Subject property address is not in lending area.
              </div>
              <Button className="backToSearch" onClick={() => props.setShowForm(true)}>Back to Search</Button>
              </>
              :
              // <div style={{color:"#6E6E70"}}>
              //   No matched product found
              // </div>
              props.errorTitle ? <>
                <div className="text-bold">{props.errorTitle}</div>
                <div className="text-normal">{props.errorMessage}</div>
              </>
              : <div className="no-matched-product-found">
                <svg xmlns="http://www.w3.org/2000/svg" width="60" height="58" viewBox="0 0 60 58" fill="none">
                  <rect x="0.5" y="3.26367" width="33.1262" height="37.6434" rx="2" fill="#C3CDEA"/>
                  <rect x="0.5" y="3.26367" width="33.1262" height="37.6434" rx="2" fill="#DFE0E8"/>
                  <rect x="14.0518" y="12.2988" width="33.1262" height="33.1262" rx="11" fill="#A4B7F8"/>
                  <rect x="5.01855" y="9.28711" width="24.0918" height="3.01147" rx="1.50573" fill="white"/>
                  <rect x="5.01855" y="16.8145" width="24.0918" height="3.01147" rx="1.50573" fill="white"/>
                  <path d="M15.5586 19.3086C15.5586 17.0995 17.3495 15.3086 19.5586 15.3086H33.6274C35.2906 15.3086 36.6389 16.6569 36.6389 18.3201C36.6389 19.9833 35.2906 21.3315 33.6274 21.3315H15.5586V19.3086Z" fill="white"/>
                  <rect x="5.01855" y="24.3438" width="9.03441" height="3.01147" rx="1.50573" fill="white"/>
                  <rect x="11.04" y="25.8496" width="25.5975" height="6.02294" rx="3.01147" fill="white"/>
                  <rect x="14.2207" y="36.6133" width="22.6397" height="6.17446" rx="3.08723" fill="white"/>
                  <rect x="5.01855" y="31.873" width="9.03441" height="3.01147" rx="1.50573" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M45.1249 43.3737C53.0632 35.4353 53.0632 22.5647 45.1249 14.6263C37.1865 6.68799 24.3159 6.68799 16.3776 14.6263C8.43921 22.5647 8.43921 35.4353 16.3776 43.3737C24.3159 51.312 37.1865 51.312 45.1249 43.3737ZM42.15 40.4005C48.4459 34.1045 48.4459 23.8968 42.15 17.6009C35.854 11.3049 25.6463 11.3049 19.3504 17.6009C13.0544 23.8968 13.0544 34.1045 19.3504 40.4005C25.6463 46.6964 35.854 46.6964 42.15 40.4005Z" fill="#525F9D"/>
                  <rect x="41.8613" y="43.2969" width="4.5172" height="12.0459" rx="2.2586" transform="rotate(-45 41.8613 43.2969)" fill="#525F9D"/>
                </svg>
                <div className="text-bold">No eligible products found</div>
                <div className="text-normal">Please refine your search fields.</div>
              </div>
          }}
          columns={maincolumns}
          scroll={{
            y: checkAccess((UR_PriceEngineUser)) ? props.viewportH- 440 : props.viewportH*0.55,
            x: 'max-content'
          }}
          expandRowByClick={true}
          rowClassName={(record,_)=> record.isConnected ? "connectedLenderRow":"unconnectedLenderRow"}
          showSorterTooltip={false}
          expandable={{
            expandedRowRender: (record) => (
              <div>
                {/* {!record.isConnected && <div className="notAddedLenderLabel"><Tooltip className="d-flex align-items-center" title="This wholesale lender is not currently added to your list of lenders. To connect with this lender, click the + button."> Not added yet <QuestionCircleOutlined style={{color:"#fffff", marginLeft:5}} />  </Tooltip></div>} */}
                <div style={{ padding: '2px 0px'}}> {/* height: 600, overflow: 'scroll' */}
                  <Row gutter={20} style={{display: 'none'}}>
                    <Col lg={8} span={24} style={{marginBottom: 12}}>
                      <div className="productDetails rate-lender-card">
                        <div style={{fontSize:"14px",color:"#586570", lineHeight: 'normal', fontWeight: 600}}>Loan summary</div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Loan amount:</div>
                              <div>${commaizeFloat(record.loanAmount)}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Loan term:</div>
                              <div>{termMap[props.loanterm]}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>LTV:</div>
                              <div>{props.loanInfo.ltv[0]}%</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>FICO:</div>
                              <div>{props.loanInfo.fico}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Escrow:</div>
                              <div>{props.loanInfo.escrow===true?"NO":"YES"}</div>
                        </div>
                        <div className="rate-lender-card-item d-flex justify-content-between">
                              <div>Lender origination fee:</div>
                              <div>${record.lender_fee}</div>
                        </div>
                      </div>
                    </Col>
                    <Col lg={16} span={24} style={{marginBottom: 12}}>
                      <div className="productDetails rate-lender-card">
                        {/* <div className="d-flex justify-content-between bold" style={{fontSize:"14px",color:"#586570", borderBottom:"1px solid #DBDCDE"}}>
                          <div>Product details</div>
                          <div style={{fontSize:"12px"}}>*Last Updated on {getCurrentDate()} 09:00</div>
                        </div> */}
                        <div style={{fontSize:"14px",color:"#586570", lineHeight: 'normal', fontWeight: 600}}>Product details</div>
                        <Row style={{ flex: 1 }}>
                          <Col lg={12} span={24}>
                            <div style={{borderRight:"1px solid #CFD4D9",paddingRight: 18, height: '100%', display: 'flex', flexDirection: 'column', gap: 10}}>
                              <div className="rate-lender-card-item d-flex justify-content-between">
                                    <div>Lender</div>
                                    <div>{com.formatLenderDisplayName(record.Lender)}</div>
                              </div>
                              <div className="rate-lender-card-item d-flex justify-content-between ">
                                    <div>Underwriting</div>
                                    <div>{record.Aus.join("/")}</div>
                              </div>
                              {typeof record.pricedetails.adjustmentPoint === "number" && record.pricedetails.adjustmentPoint !== 0 && (
                                <div className="rate-lender-card-item d-flex justify-content-between">
                                  <div>Applied adjustments</div>
                                  <div>{formatPricePoints(record.pricedetails.adjustmentPoint)}%</div>
                                </div>
                              )}
                              {
                                record.Adjustments && Object.keys(record.Adjustments).length > 0 && Object.entries(record.Adjustments).map(([key, value]) => (
                                  <div className="rate-lender-card-item d-flex justify-content-between" style={{color:"#6E6E70"}}>
                                    <div>{handleName(key)}</div>
                                    <div>{value}%</div>
                                  </div>
                                ))
                              }
                            </div>
                          </Col>

                          <Col lg={12} span={24}>
                              <div style={{paddingLeft: 18, height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
                                <div style={{display: 'flex', flexDirection: 'column', gap: 10}}>
                                  <div className="rate-lender-card-item d-flex justify-content-between">
                                      <div>Lock day:</div>
                                      <div>{record.lockDay}</div>
                                  </div>
                                  {record.fhamip && <>
                                    <div className="rate-lender-card-item d-flex justify-content-between">
                                        <div>Upfront MIP</div>
                                        <div>${record.fhamip.upfrontMIP.toFixed(0)}</div>
                                    </div>
                                    <div className="rate-lender-card-item d-flex justify-content-between">
                                          <div>Monthly MIP</div>
                                          <div>${record.fhamip.monthlyMIP.toFixed(0)}</div>
                                    </div>
                                  </>}
                                </div>
                                <div style={{fontSize: 12, color: '#6E6E70', textAlign: 'right'}}>*Last Updated on {getCurrentDate()} 09:00</div>
                              </div>
                          </Col>
                        </Row>
                      </div>
                    </Col>

                  </Row>
                  {/* new row*/}
                  {/* <div className="other-rates-title">Detail
                    <span style={{color: '#325ceb', fontSize: 12}} className="cursor-pointer" onClick={() => setShowRowDetail(!showRowDetail)}>
                      &nbsp;
                      {showRowDetail ? 'collapse' : 'expand'}
                    </span>
                  </div> */}
                  {row_detail(record)}
                  <div className="other-rates-title">Other rates</div>
                  <div className="justify-content-center" style={{marginBottom: 10}}>
                    {(() => {
                      const innerData = targetTab.intabledata[record.program] || [];
                      const isExpanded = expandedInnerTableStates[record.key];
                      const displayData = isExpanded ? innerData : innerData.slice(0, 5);
                      const hasMoreData = innerData.length > 5;
                      
                      return (
                        <>
                          <Table 
                            style={{border: '1px solid #DBDCDE', borderRadius: !isExpanded ? '8px 8px 0 0' : '8px 8px 0 0', overflow: 'hidden'}}
                            className="innertable rates-innertable"
                            pagination={false}
                            showHeader={true}
                            columns={innerColumns}
                            dataSource={displayData}
                            rowClassName="innerTableRow"
                          />
                          {hasMoreData && !isExpanded && (
                            <div style={{
                              textAlign: 'center', 
                              marginTop: 0, 
                              marginBottom: 0,
                              border: '1px solid #DBDCDE',
                              borderTop: 'none',
                              backgroundColor: '#fff',
                              padding: '14px 0',
                              borderRadius: '0 0 8px 8px'
                            }}>
                              <Button 
                                type="link" 
                                onClick={() => handleShowAllRates(record.key)}
                                style={{color: '#325CEB', fontSize: 14, fontWeight: 500}}
                              >
                                Show all rates ({innerData.length})
                              </Button>
                            </div>
                          )}
                          {hasMoreData && isExpanded && (
                            <div style={{
                              textAlign: 'center', 
                              marginTop: 0, 
                              marginBottom: 0,
                              border: '1px solid #DBDCDE',
                              borderTop: 'none',
                              backgroundColor: '#fff',
                              padding: '14px 0',
                              borderRadius: '0 0 8px 8px'
                            }}>
                              <Button 
                                type="link" 
                                onClick={() => handleCollapseRates(record.key)}
                                style={{color: '#325CEB', fontSize: 14, fontWeight: 500}}
                              >
                                Show less rates
                              </Button>
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>
                </div>
              </div>
            ),
            rowExpandable: record => !props.mobileHomeLenders.includes(record.Lender),
            expandIcon:({expanded,onExpand, record})=>{
              return(
                props.mobileHomeLenders.includes(record.Lender) ? 
                  ""
                : (
                  <div style={{ textAlign: 'right' }}>
                    <img
                      src={`/images/rates-lenders-${expanded ? 'up' : 'down'}.svg`}
                      style={{cursor: "pointer"}} 
                      onClick={(e)=>{
                        onExpand(record,e)
                      }}
                    />
                  </div>
                )
              )
            }
          }}
        />)
      }

    <Modal
      open={showAddLenderModal}
      onCancel={()=>setShowAddLendersModal(false)}
      centered
      footer={[
        <Button key="back" onClick={()=>setShowAddLendersModal(false)}>
          Cancel
        </Button>,
      ]}
      width={1000}
    >
      <Lenders />
    </Modal>
    <Modal
      title="Share Rates"
      open={showShareRateModal}
      onCancel={()=>setShowShareRatesModal(false)}
      centered
      footer={[
        <Button type="primary" onClick={()=>setShowShareRatesModal(false)}>
          Share
        </Button>,
      ]}
    >
      <div className="p-3">
        <div className="title-5">Borrower Email</div>
        <Input placeholder="email@example.com"/>

        <div className="title-5">Selected rates</div>
        {/* {displaySelectedRates(selectedRows)} */}
        
        <div className="title-5">Additonal information (optional)</div>
        <TextArea rows={4} placeholder="Enter your infomation..." maxLength={6} />


      </div>
    
    </Modal>
    <ClosingCostFeeModal
      show={showClosingCostDetailModal}
      onHide={() => setShowClosingCostDetailModal(false)}
      filterParams={props.searchParams}
      selectedLoan={currentLoan}
      detailedCard={currentRecord}
      closingCostsDetail={props.appliedClosingCostsDetail}
      detailType="all"
      statsigSource={props.statsigSource}
      isExporting={false}
      // onExport={() => {}}
    />
    <CompareProduct
      open={compareModal}
      tableData={[
        ...targetTab.outtabledata.filter(item => selectedRowKeys.includes(item.key)),
        ...Object.values(targetTab.intabledata)
          .flat()
          .filter(item => selectedRowKeys.includes(item.key))
      ]}
      cancelSelect={cancelSelect}
      onCancel={compareModalCancel}
    >
    </CompareProduct>      
    </div>
  );
}
